'use client'

import { useSearchParams } from 'next/navigation'
import { useTranslations } from 'next-intl'
import { KeyboardEvent, useState } from 'react'

import { useRouter } from '@/shared/i18n'
import { Slot } from '@/shared/lib'
import { Icon, TextField } from '@/shared/ui'

type Props = {
  keyword?: string
}

export const MobileSearch = ({ keyword }: Props) => {
  const router = useRouter()
  const searchParams = useSearchParams()

  const t = useTranslations('faq')

  const [value, setValue] = useState(keyword ?? '')

  const handleSearch = () => {
    const params = new URLSearchParams(searchParams?.toString() ?? '')

    params.delete('category')

    if (value) {
      params.set('keyword', value)
    } else {
      params.delete('keyword')
    }

    router.push(`?${params.toString()}`)
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value)
  }

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSearch()
    }
  }

  const handleInputReset = () => {
    setValue('')
  }

  return (
    <div className="py-[3px] pl-[5px]">
      <TextField
        value={value}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        onReset={handleInputReset}
        placeholder={t('search.placeholder')}
        className="h-[50px] w-full border-none bg-[rgba(0,0,0,0)] text-[15px]! leading-[22px]! *:placeholder:text-gray-400"
        fullWidth
      >
        <Slot name="left">
          <Icon
            name="search"
            size={24}
            className="text-black"
            strokeWidth={1.5}
          />
        </Slot>
      </TextField>
    </div>
  )
}
